import styled from 'styled-components';


const StyledNumbersCol = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex: ${props => props.isImage ? '0 0 60%' : '0 0 40%'};
  width: ${props => props.isImage ? '60%' : '40%'};
  height: ${props => props.isImage ? 'auto' : '100%'};
  .is-column:nth-child(1){
    margin-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;
  }
  @media screen and (max-width: 1439px){
  }
  @media screen and (max-width: 1023px){
    .is-column:nth-child(1){
      margin-bottom: ${props => props.theme.components_spacing_tablet.xlarge}px;
    }
  }
  @media screen and (max-width: 767px){
    width: 100%;
    .is-column:nth-child(1){
      margin-bottom: ${props => props.theme.components_spacing_mobile.xlarge}px;
    }
  }
`;

export {
  StyledNumbersCol,
};

